import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
// import { Box } from '@pancakeswap/uikit'
import Container from 'components/Layout/Container'

// const Outer = styled(Container)`
//   background: ${({ theme, background }) => background || theme.colors.gradients.bubblegum};
// `

import tractor from './img/tractor.svg'
import launchpad from './img/launchpad.svg'
import appearAnim from './anim'

const imagesSet = [
  { name: 'tractor', src: tractor },
  { name: 'launchpad', src: launchpad },
]

const Image = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`

const Inner = styled.div`
  position: relative;
  padding: 45px 28px;
  min-height: 320px;
  background: #fff;
  border-radius: 16px;
  background-image: url("data:image/svg+xml,%3Csvg width='1114' height='320' viewBox='0 0 1114 320' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M87.5668 -605.325C338.567 -404.825 929.393 -304.664 1121.57 -347.325C1679.37 153.675 -122.979 491.718 -305.793 67.0337C-488.606 -357.65 -610.459 -630.853 -588.433 -717.325C-566.407 -803.796 -163.433 -805.825 87.5668 -605.325Z' stroke='url(%23paint0_linear)' stroke-width='2'/%3E%3Cpath d='M75.0537 -650.348C326.054 -449.848 830.337 -493.828 1022.51 -536.489C1580.31 -35.4894 -135.492 446.694 -318.306 22.0105C-501.119 -402.673 -581.472 -788.876 -559.446 -875.348C-537.421 -961.819 -175.946 -850.848 75.0537 -650.348Z' stroke='url(%23paint1_linear)' stroke-width='2'/%3E%3Cpath d='M246.568 -677.921C497.568 -477.421 959.893 -707.26 1152.07 -749.921C1866.61 91.2207 -214.119 458.263 -396.932 33.5792C-579.746 -391.105 -407.433 -1630.92 -229.432 -1360.42C-142.936 -1228.98 -382.932 -1193.92 -348.432 -1042.42C-313.932 -890.921 117.537 -780.991 246.568 -677.921Z' stroke='url(%23paint2_linear)' stroke-width='2'/%3E%3Cpath d='M274.241 -741.577C598.815 -717.656 927.286 -1048.82 1103.21 -1137.15C2001.63 -496.114 105.163 472.737 -175.885 105.601C-456.934 -261.535 -592.81 -1505.87 -354.106 -1287.07C-238.112 -1180.75 -156.373 -1355.47 -316.049 -1039.88C-475.726 -724.298 -50.3318 -765.497 274.241 -741.577Z' stroke='url(%23paint3_linear)' stroke-width='2'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='1055.11' y1='36.8392' x2='356.053' y2='375.283' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2325BA46' stop-opacity='0.4'/%3E%3Cstop offset='1' stop-color='%2325BA46' stop-opacity='0'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear' x1='972.09' y1='-50.4209' x2='406.322' y2='246.524' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2325BA46' stop-opacity='0.4'/%3E%3Cstop offset='1' stop-color='%2325BA46' stop-opacity='0'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear' x1='1131.88' y1='-136.738' x2='333.409' y2='202.757' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2325BA46' stop-opacity='0.4'/%3E%3Cstop offset='1' stop-color='%2325BA46' stop-opacity='0'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint3_linear' x1='1257.09' y1='-446.904' x2='227.261' y2='121.48' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%2325BA46' stop-opacity='0.4'/%3E%3Cstop offset='1' stop-color='%2325BA46' stop-opacity='0'/%3E%3C/linearGradient%3E%3CclipPath id='clip0'%3E%3Crect width='1114' height='320' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
`

const PageHeader: React.FC<{ image?: string }> = ({ image, children, ...props }) => {
  const iconRef = useRef(null)

  useEffect(() => {
    appearAnim({ icon: iconRef.current })
  }, [])
  return (
    <Container {...props}>
      <Inner>
        {children}
        {image && (
          <Image ref={iconRef}>
            <img src={imagesSet?.find(({ name }) => name === image)?.src} alt="Illustration" />
          </Image>
        )}
      </Inner>
    </Container>
  )
}

export default PageHeader
